/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

// 13-Dec-2024 Popup Cookie
class PopupCookie {
  constructor(name, value, daysToExpire = 7) {
    const today = new Date();
    const expiresDate = new Date();
    expiresDate.setTime(today.getTime() + 3600000 * 24 * daysToExpire);

    this.configuration = {
      expires: expiresDate.toGMTString(),
      path: "/",
      domain: window.location.hostname,
      sameSite: "none",
      secure: true,
    };
    this.name = name;
    this.value = value;
  }

  write() {
    const hasCookie =
      document.cookie.indexOf("; ") !== -1 &&
      !document.cookie.split("; ").find((row) => row.startsWith(this.name));

    if (hasCookie || document.cookie.indexOf("; ") === -1) {
      document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`;
    }
  }

  read() {
    if (
      document.cookie.indexOf("; ") !== -1 &&
      document.cookie.split("; ").find((row) => row.startsWith(this.name))
    ) {
      const returnCookie = document.cookie
        .split("; ")
        .find((row) => row.startsWith(this.name))
        .split("=")[1];

      return returnCookie;
    } else {
      return false;
    }
  }
}
function checkCookie() {
  const cookie = new PopupCookie("userConsent", "true");
  return cookie.read();
}
$("#setCookieButton,#NosetCookieButton").on("click", function () {
  const cookie = new PopupCookie("userConsent", "true", 7);
  cookie.write();
  $(".popup-cookies").hide();
});
// $("#NosetCookieButton").on("click", function () {
//   $(".popup-cookies").hide();
// });
if (checkCookie()) {
  $(".popup-cookies").hide();
} else {
  $(".popup-cookies").show();
  $("div#Popup--popups-0").attr("style", "display: block !important;");
}
// 13-Dec-2024 Popup Cookie
// $('body').on('click','a.sub_menu_link',function () {

//     $(this).parents('.sub_menu_bar').find('ul.sub-menu.drop-down').toggleClass('is-menu-active');
// })
$("body")
  .on("mouseenter", ".collection-image", function () {
    var image = $(this).attr("data-image");
    var title = $(this).attr("data-title");
    if (typeof image === "undefined") {
      $(".visibility-div").removeClass("image-found");
    } else {
      $(".visibility-div").addClass("image-found");
      $(".visibility-div img").attr("src", image);
      $(".visibility-div .navlink span").html(title);
    }
  })
  .on("mouseleave", "div", function () {
    $(".visibility-div").removeClass("image-found");
    $(".visibility-div img").attr("src", "");
    $(".visibility-div .navlink span").html("");
  });
// product see chart start
$("body").on("click", "span.custom_see_chart_jtpl", function () {
  $(".custom_see_chart_table_wrapper").show();
  $("body").addClass("product_see_chart_open");
});
$("body").on("click", "svg.custom_pdp_cross_icon_jtpl", function () {
  $(".custom_see_chart_table_wrapper").hide();
  $("body").removeClass("product_see_chart_open");
});
$("body").on("click", ".inner_body_close", function () {
  //alert();
  $("body").removeClass("product_see_chart_open");
  $(".custom_see_chart_table_wrapper").hide();
});

$(".sibling__link_btn").click(function () {
  $(".sibling__link_btn").removeClass("sibling__link--current");
  $(this).addClass("sibling__link--current");
  var ComparepriceMoney = $(this).attr("data-compare-without-money");

  var ProductriceMoney = $(this).attr("data-without-money");

  var getReviews = $(this).attr("data-review");
  var getpReviews = $(this).attr("data-preview");
  var getDesc = $(this).attr("data-desc");
  var upsellTitle = $(this).attr("data-upsellTitle");
  var upsellPrice = $(this).attr("data-upsellPrice");
  var upsellid = $(this).attr("data-upsellid");
  var upsellImg = $(this).attr("data-upsellImg");
  var upsellHanle = $(this).attr("data-upsellHanle");
  var dataCutline = $(this).data("cutline");
  var dataUrl = $(this).data("url");
  var producttitle = $(this).data("title");
  var productPrice = $(this).data("price");
  var productId = $(this).data("id");
  var productImage = $(this).data("img");
  var productImage1 = $(this).data("img1");
  var productImage2 = $(this).data("img2");
  var productImage3 = $(this).data("img3");
  var productImage4 = $(this).data("img4");
  var productImage5 = $(this).data("img5");
  var productImage6 = $(this).data("img6");
  var productImage7 = $(this).data("img7");
  var productImage8 = $(this).data("img8");
  var productImage9 = $(this).data("img9");
  var productImage10 = $(this).data("img10");
  var productImage11 = $(this).data("img11");
  var productImage12 = $(this).data("img12");
  var productComapreprice = $(this).attr("data-compare-price");
  console.log(productComapreprice);
  if (productComapreprice == "") {
    $("s.product__price--strike").hide();
    $("span.product__price--off").hide();
    $("span.product__price--sale").css("color", "#212121");
  } else {
    $("s.product__price--strike").show();
    $("span.product__price--off").show();
    $("span.product__price--sale").css("color", " #d30808");

    var getPercentage = Math.floor(
      ((ComparepriceMoney - ProductriceMoney) * 100) / ComparepriceMoney
    );

    $("span.product__price--off").text(`${getPercentage}% OFF`);
    $(".product__price--off").removeClass("hidden");
    $(".product__block .product__price").html(
      `<span data-product-price="" class="product__price--sale">${productPrice}</span><span class="visually-hidden" data-compare-text="">Regular price</span><s class="product__price--strike" data-compare-price="">${productComapreprice}</s>`
    );
  }
  $(".p_upsell_link").attr("href", upsellHanle);
  $(".upsell_id").val(upsellid);
  $(".product-upsell__image__thumb figure img").attr("srcset", upsellImg);
  $(".product-upsell__image__thumb figure img").attr("src", upsellImg);
  $(".new-price").text(upsellPrice);
  $(".product-upsell__title").text(upsellTitle);
  $(".product__title").text(producttitle);
  $(".product__title_bread").text(producttitle);
  $(".review_div").html(" ");
  $(".review_div").html(getReviews);
  $(".product-summary").html(" ");
  $(".product-summary").html(getpReviews);
  $(".radio__legend__value").text(dataCutline);
  $(".dataCutline").val(dataCutline);
  $(".cart-bar__product__title").text(producttitle);
  $(".product__price span").text(productPrice);
  $(".product_id_change").val(productId);
  $(".product__description__content__entry").html(" ");
  $(".product__description__content__entry").html(getDesc);

  window.history.pushState("page2", "Title", "/products/" + dataUrl);

  $(".image_replace_1").attr("data-image-src", productImage);
  $(".image_replace_1 figure img").attr("src", productImage);
  $(".image_replace_1 figure img").attr("srcset", productImage);
  $(".image_replace_2").attr("data-image-src", productImage1);
  $(".image_replace_2 figure img").attr("src", productImage1);
  $(".image_replace_2 figure img").attr("srcset", productImage1);
  $(".image_replace_3").attr("data-image-src", productImage2);
  $(".image_replace_3 figure img").attr("src", productImage2);
  $(".image_replace_3 figure img").attr("srcset", productImage2);
  $(".image_replace_4").attr("data-image-src", productImage3);
  $(".image_replace_4 figure img").attr("src", productImage3);
  $(".image_replace_4 figure img").attr("srcset", productImage3);

  $(".image_replace_5").attr("data-image-src", productImage4);
  $(".image_replace_5 figure img").attr("src", productImage4);
  $(".image_replace_5 figure img").attr("srcset", productImage4);
  console.log(
    productImage5 +
      "5==" +
      productImage6 +
      "6===" +
      productImage7 +
      "7==" +
      productImage8 +
      "8==="
  );

  if (productImage6 != null) {
    $(".image_replace_6").show();
    $(".image_replace_6").attr("data-image-src", productImage5);
    $(".image_replace_6 figure img").attr("src", productImage5);
    $(".image_replace_6 figure img").attr("srcset", productImage5);
  } else {
    $(".image_replace_6").hide();
  }
  if (productImage6 != null) {
    $(".image_replace_7").show();
    $(".image_replace_7").attr("data-image-src", productImage6);
    $(".image_replace_7 figure img").attr("src", productImage6);
    $(".image_replace_7 figure img").attr("srcset", productImage6);
  } else {
    $(".image_replace_7").hide();
    // alert("Hello");
  }
  if (productImage7 != null) {
    $(".image_replace_8").show();
    $(".image_replace_8").attr("data-image-src", productImage7);
    $(".image_replace_8 figure img").attr("src", productImage7);
    $(".image_replace_8 figure img").attr("srcset", productImage7);
  } else {
    $(".image_replace_8").hide();
    // alert("Hello");
  }
  if (productImage8 != null) {
    $(".image_replace_9").show();
    $(".image_replace_9").attr("data-image-src", productImage8);
    $(".image_replace_9 figure img").attr("src", productImage8);
    $(".image_replace_9 figure img").attr("srcset", productImage8);
  } else {
    $(".image_replace_9").hide();
  }
  if (productImage9 != null) {
    $(".image_replace_10").show();
    $(".image_replace_10").attr("data-image-src", productImage9);
    $(".image_replace_10 figure img").attr("src", productImage9);
    $(".image_replace_10 figure img").attr("srcset", productImage9);
  } else {
    $(".image_replace_10").hide();
  }
  if (productImage10 != null) {
    $(".image_replace_11").show();
    $(".image_replace_11").attr("data-image-src", productImage10);
    $(".image_replace_11 figure img").attr("src", productImage10);
    $(".image_replace_11 figure img").attr("srcset", productImage10);
  } else {
    $(".image_replace_11").hide();
  }
  if (productImage11 != null) {
    $(".image_replace_12").show();
    $(".image_replace_12").attr("data-image-src", productImage10);
    $(".image_replace_12 figure img").attr("src", productImage10);
    $(".image_replace_12 figure img").attr("srcset", productImage10);
  } else {
    $(".image_replace_12").hide();
  }
});

$("body").on("click", ".main_sub_menu", function () {
  var menuClass = $(this).attr("data-menu");
  $(".sub-menu.jtpl-" + menuClass).slideToggle();
  $(this).toggleClass("arrow-show");
});
var getAttrtrue = $(".index-product.section-padding").attr(
  "data-sticky-enabled"
);
console.log(getAttrtrue);
if (getAttrtrue == "true") {
  $(".product__page .form__wrapper").addClass("is-sticky");
} else {
  $(".product__page .form__wrapper").removeClass("is-sticky");
}
if ($(window).width() < 767) {
  $(".product__page .form__wrapper").removeClass("is-sticky");
  $(
    ".custom_product__images.product__images--has-thumbs .product__slides"
  ).slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    fade: true,
    adaptiveHeight: true,
  });
} else {
  // $('.custom_product__images.product__images--has-thumbs .product__slides').unslick();
}
(function () {
  // Add custom code below this line

  $("body").on("click", ".product__thumb .product__thumb__link", function (e) {
    e.preventDefault();

    var getThumbimage = $(this).attr("data-med-id");
    console.log(getThumbimage);

    $(".custom_product__images .product__slide").each(function () {
      var getProductId = $(this).attr("data-image-id");

      // Check if the IDs match
      if (getProductId == getThumbimage) {
        var gteSlickIndex = $(this).attr("data-slick-index");
        console.log(gteSlickIndex);

        // Go to the corresponding slide
        $(
          ".custom_product__images.product__images--has-thumbs .product__slides"
        ).slick("slickGoTo", parseInt(gteSlickIndex)); // Ensure the index is a number
      }
    });
  });

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your variables into the global scope.
})();

$(document).ready(function () {
  if ($(window).width() < 758) {
    var headerHeight = $("header.theme__header").height();
    $(".main-content").css("padding-top", headerHeight);
    // alert(headerHeight);
  }
  if ($(window).width() < 684) {
    $(document).on("click", ".sliderule__wrapper", function (e) {
      e.stopPropagation();
      $(this).find("ul.sub-menu.drop-down").css("display", "block");
    });
  }
});
